import _ from "lodash";
import { memo } from "react";
import { NextPage } from "next";
import { HiOutlineChevronRight } from "react-icons/hi";
import styled from "@emotion/styled";
import { IArticle } from "src/interface/section";
import { splitRote } from "src/utils/helper";
import { IBreadcrumbData } from "src/interface/widgets";

type Props = {
  color?: string;
  data?: IArticle;
  router?: any;
  className?: string;
};
const WidgetBreadcrumb: NextPage<Props> = ({
  color = "#000",
  data,
  router = null
}) => {
  if (_.isEmpty(data)) return null;
  const themePage = router ? splitRote(router) : "";
  const _data: IBreadcrumbData[] = [
    {
      icon: "",
      nameTh: "หน้าแรก",
      nameEng: "หน้าแรก",
      link: null
    },
    {
      icon: <HiOutlineChevronRight />,
      nameTh:
        router?.pathname !== `${themePage}/galleries/[id]`
          ? `${data.section?.th}` || ""
          : "แกลลอรี่",
      nameEng: data.section?.en || "",
      link:
        router?.pathname !== `${themePage}/galleries/[id]`
          ? `/category/${data.section?.en || ""}`
          : ""
    },
    {
      icon: <HiOutlineChevronRight />,
      nameTh:
        router?.pathname !== `${themePage}/galleries/[id]`
          ? data.subCategory?.th
          : data.title,
      nameEng: data.subCategory?.en || "",
      link:
        router?.pathname !== `${themePage}/galleries/[id]`
          ? `/category/${data.section?.en || ""}/${data.subCategory?.en || ""}`
          : router.asPath
    },
    {
      icon: <HiOutlineChevronRight />,
      nameTh:
        router?.pathname === `${themePage}/video/[cid]`
          ? router.query.sub || router.query.cid
          : "",
      nameEng: "",
      link: router?.asPath
    }
  ];

  return (
    <WidgetWrapper id='widget-breadcrumb' color={color}>
      {/* <div className='cat--title'>
        <p>{data.subCategory?.th ? data.subCategory?.th : router?.pathname === `${themePage}/galleries/[id]` ? 'แกลลอรี่' : data.section?.th}</p>
      </div> */}
      <nav aria-label='breadcrumb'>
        <ul className='breadcrumb'>
          {_data.map(
            (item: IBreadcrumbData, index: number) =>
              item.nameTh && (
                <li key={index} className='breadcrumb-item'>
                  {item.icon}
                  {item.link ? (
                    <a
                      href={item.link}
                      title={item.nameTh}
                      aria-label={item.nameTh}
                    >
                      <span>{item.nameTh}</span>
                    </a>
                  ) : (
                    <a href='/' title={item.nameTh} aria-label={item.nameTh}>
                      {item.nameTh}
                    </a>
                  )}
                </li>
              )
          )}
          {data.title && (
            <li className='breadcrumb-item title'>
              <HiOutlineChevronRight />
              <span>{data.title}</span>
            </li>
          )}
        </ul>
      </nav>
    </WidgetWrapper>
  );
};

const WidgetWrapper = styled.div`
  position: relative;
  display: flex;
  max-width: 1300px;
  margin: auto;
  color: #fff;
  padding-top: 15px;
  /* padding-top: 30px; */
  @media (max-width: 767px) {
    flex-direction: column;
    /* padding: 30px 0 10px 5px; */
  }
  .cat--title {
    position: relative;
    background: var(--primary-color);
    max-width: max-content;
    padding: 5px 16px;
    color: #fff;
    margin: 0 20px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    @media (max-width: 475px) {
      padding: 2px 8px;
      margin: 0 10px 0 0;
    }
    p {
      font-size: 16px;
      font-weight: 500;
      @media (max-width: 768px) {
        font-size: 14px;
      }
      @media (max-width: 475px) {
        font-size: 12px;
      }
    }
  }
  ul.breadcrumb {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    padding-bottom: 15px;
    @media (max-width: 768px) {
      padding: 10px 0 10px;
    }
    @media (max-width: 475px) {
      padding: 5px 0 5px;
    }
    a {
      text-transform: capitalize;
      font-weight: 300;
      font-size: 14px;
      color: #515151;
      &:hover {
        color: #1e9245;
      }
    }
    svg {
      color: #515151;
      font-weight: 300;
    }
    .breadcrumb-item {
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      &.title {
        color: #515151;
        @media (max-width: 690px) {
          display: none;
        }
      }

      a {
        font-size: 14px;
        font-weight: normal;
        
        span {
          color: var(--primary-color);
        }
      }
      &:not(:last-child) {
        span {
          color: #515151;
        }
      }
      &:last-child {
        span {
          color: #515151;
        }
        a {
          color: #04091B;;
          pointer-events: none;
          user-select: none;
        }
      }
    }
  }
  @media (max-width: 1024px) {
    ul.breadcrumb {
      a {
        font-size: 14px;
      }
    }
  }
`;

export default memo(WidgetBreadcrumb);
